"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollLock = void 0;
const react_1 = require("react");
const activeLockers = new Set();
let originalBodyStyles = null;
let storedScrollY = 0;
/**
 * Prevents body scroll when modal/drawer is open and restores scroll position when closed.
 *
 * Uses a Set to track all active lockers:
 * - First locker stores original styles and scroll position
 * - Only the last to unlock restores the original state
 */
const useScrollLock = (isLocked) => {
    const idRef = (0, react_1.useRef)(Symbol('scroll-locker'));
    const isLockedRef = (0, react_1.useRef)(false);
    const handleLock = (0, react_1.useCallback)(() => {
        isLockedRef.current = true;
        activeLockers.add(idRef.current);
        if (activeLockers.size === 1) {
            const body = document.body;
            const computedStyle = window.getComputedStyle(body);
            originalBodyStyles = {
                overflow: computedStyle.overflow,
                position: computedStyle.position,
                top: computedStyle.top,
                width: computedStyle.width,
            };
            storedScrollY = window.scrollY;
            body.style.overflow = 'hidden';
            body.style.position = 'fixed';
            body.style.top = `-${storedScrollY}px`;
            body.style.width = '100%';
        }
    }, []);
    const handleUnlock = (0, react_1.useCallback)(() => {
        isLockedRef.current = false;
        activeLockers.delete(idRef.current);
        if (activeLockers.size === 0 && originalBodyStyles) {
            const body = document.body;
            body.style.overflow = originalBodyStyles.overflow;
            body.style.position = originalBodyStyles.position;
            body.style.top = originalBodyStyles.top;
            body.style.width = originalBodyStyles.width;
            if (typeof window.scrollTo === 'function') {
                window.scrollTo(0, storedScrollY);
            }
            originalBodyStyles = null;
            storedScrollY = 0;
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (isLocked && !isLockedRef.current) {
            handleLock();
        }
        else if (!isLocked && isLockedRef.current) {
            handleUnlock();
        }
        return () => {
            if (isLockedRef.current) {
                handleUnlock();
            }
        };
    }, [handleLock, handleUnlock, isLocked]);
};
exports.useScrollLock = useScrollLock;
//# sourceMappingURL=index.js.map